import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import * as echarts from 'echarts';
export default {
  name: "multiBarChart",
  props: {
    data: {
      type: Array,
      default: () => {
        return [20];
      }
    },
    total: {
      type: Number,
      default: 0
    }
  },
  watch: {
    data() {
      this.$nextTick(() => this.render());
    }
  },
  methods: {
    getOption1() {
      const data1 = this.data.map(item => {
        return {
          value: item.rank,
          name: item.name,
          rankUserCnt: item.rankUserCnt,
          rightRank: item.rightRank
        };
      });
      const maxUserNum = Math.max(...this.data.map(item => item.rankUserCnt));
      console.log(data1);
      return {
        title: {
          text: '评级',
          subtext: '系统会综合你的历史做题及平台历史做题，给出你的评级'
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            console.log(params);
            const rankMap = function (value) {
              const texts = [];
              // 根据数值返回对应的中文标签
              if (value === 5) {
                texts.push('A');
              } else if (value === 4) {
                texts.push('B');
              } else if (value === 3) {
                texts.push('C');
              } else if (value === 2) {
                texts.push('D');
              } else if (value === 1) {
                texts.push('E');
              }
              return texts; // 其他数值原样显示
            };
            return '<div><span style="color:#5070dd">等级：' + rankMap(params[0]?.data?.value) + '</span> </div>' + '<div><span style="color:#77DD77">排名总人数：' + params[0]?.data?.rankUserCnt + '</span> </div>' + '<div><span style="color:#FFD700">综合名次：' + params[0]?.data?.rightRank + '</span></div>';
          }
        },
        legend: {
          left: 'center'
        },
        xAxis: [{
          type: 'category',
          data: this.data.map(item => item.name),
          axisLabel: {
            //x轴文字的配置
            show: true,
            interval: 0,
            //使x轴文字显示全
            itemStyle: {
              color: 'white'
            },
            formatter: function (params) {
              var newParamsName = "";
              var paramsNameNumber = params.length;
              var provideNumber = 3; //一行显示几个字
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
              if (paramsNameNumber > provideNumber) {
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = "";
                  var start = p * provideNumber;
                  var end = start + provideNumber;
                  if (p == rowNumber - 1) {
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr;
                }
              } else {
                newParamsName = params;
              }
              return newParamsName;
            }
          }
        }],
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: function (value) {
              const texts = [];
              // 根据数值返回对应的中文标签
              if (value === 5) {
                texts.push('A');
              } else if (value === 4) {
                texts.push('B');
              } else if (value === 3) {
                texts.push('C');
              } else if (value === 2) {
                texts.push('D');
              } else if (value === 1) {
                texts.push('E');
              }
              return texts; // 其他数值原样显示
            }
          },
          max: 5,
          min: 0
        }, {
          type: 'value',
          name: '排名',
          min: 0,
          max: maxUserNum,
          interval: 30,
          axisLabel: {
            formatter: '{value}'
          }
        }],
        series: [{
          name: '级别',
          type: 'bar',
          data: data1,
          label: {
            show: true,
            // 显示标签
            position: 'inside',
            formatter: function (params) {
              const value = params.data.value;
              if (value === 5) {
                return 'A';
              } else if (value === 4) {
                return 'B';
              } else if (value === 3) {
                return 'C';
              } else if (value === 2) {
                return 'D';
              } else if (value === 1) {
                return 'E';
              }
            },
            textStyle: {
              color: 'black'
            }
          }
        }, {
          name: '排名总人数',
          type: 'bar',
          yAxisIndex: 1,
          data: this.data.map(item => {
            return {
              value: item.rankUserCnt,
              name: item.name
            };
          })
        }, {
          name: '综合名次',
          type: 'bar',
          yAxisIndex: 1,
          data: this.data.map(item => {
            return {
              value: item.rightRank + 1,
              name: item.name
            };
          })
        }]
      };
    },
    getOption2() {
      const l = this.data.map(item => item.totalQuestion);
      const maxNum = Math.max(...l);
      return {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          data: ['做题数量', '正确数量', '错误数量', '正确率']
        },
        xAxis: [{
          type: 'category',
          data: this.data.map(item => item.name),
          axisPointer: {
            type: 'shadow'
          }
        }],
        yAxis: [{
          type: 'value',
          name: '做题数量',
          min: 0,
          max: maxNum,
          interval: 30,
          axisLabel: {
            formatter: '{value}'
          }
        }, {
          type: 'value',
          name: '正确率',
          min: 0,
          max: 100,
          interval: 20,
          axisLabel: {
            formatter: '{value} %'
          }
        }],
        series: [{
          name: '做题数量',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value;
            }
          },
          data: this.data.map(item => item.totalQuestion)
        }, {
          name: '正确数量',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value;
            }
          },
          data: this.data.map(item => item.totalRightAns)
        }, {
          name: '错误数量',
          type: 'bar',
          tooltip: {
            valueFormatter: function (value) {
              return value;
            }
          },
          data: this.data.map(item => item.totalWrongAns)
        }, {
          name: '正确率',
          type: 'line',
          yAxisIndex: 1,
          tooltip: {
            valueFormatter: function (value) {
              return value + '%';
            }
          },
          data: this.data.map(item => item.totalRightAns + item.totalWrongAns ? 100 * (item.totalRightAns / (item.totalRightAns + item.totalWrongAns)).toFixed(2) : 0)
        }]
      };
    },
    render() {
      let barChar1 = document.getElementById('levelBarChart');
      let barChar2 = document.getElementById('accuracyBarChart');
      let exist1 = echarts.getInstanceByDom(barChar1);
      let exist2 = echarts.getInstanceByDom(barChar2);
      if (exist1) {
        console.log(this.id, '1销毁已存在的');
        exist1.dispose();
      }
      if (exist2) {
        console.log(this.id, '2销毁已存在的');
        exist2.dispose();
      }
      let chart1 = echarts.init(barChar1);
      let chart2 = echarts.init(barChar2);
      chart1.setOption(this.getOption1());
      chart2.setOption(this.getOption2());
    },
    init() {
      this.$nextTick(() => this.render());
    }
  },
  mounted() {
    this.init();
  }
};